/**
 * Fetches a BEE editor template JSON from an external URL (e.g. the Beefree
 * GitHub template repository).
 *
 * This is intentionally a raw `fetch`: the template lives on an external CDN, not
 * the Apollo backend, so it is not modeled by the generated Orval client / mutator.
 * Keeping it in the API layer keeps containers free of direct network calls.
 */
export const fetchBeeTemplate = async (
  templateUrl: string,
  signal: AbortSignal,
): Promise<unknown> => {
  try {
    const response = await fetch(templateUrl, { signal });
    if (!response.ok) {
      throw new Error(`Failed to fetch BEE template (HTTP ${response.status})`);
    }
    return await response.json();
  } catch (error) {
    if ((error as Error)?.name === "AbortError") {
      throw error;
    }

    console.error("Failed to fetch template:", error);
    throw error;
  }
};
